// src/apiEmail.js
const WORKER_URL = "https://send-mailgun.reservas-cuchillaalta.workers.dev/send";

/**
 * Envía un correo a través del Worker (Cloudflare + Mailgun)
 * @param {Object} params
 * @param {string} params.to      - destino principal
 * @param {string} params.subject - asunto
 * @param {string} [params.html]  - cuerpo HTML
 * @param {string} [params.text]  - cuerpo texto plano
 * @param {string} [params.cc]    - CC (opcional)
 * @param {string} [params.bcc]   - BCC (opcional)
 * @param {string} [params.from]  - Remitente (opcional, por defecto el del Worker)
 */
export async function enviarMail({ to, subject, html, text, cc, bcc, from }) {
  console.log("[mail] →", { to, subject });

  const res = await fetch(WORKER_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ to, subject, html, text, cc, bcc, from }),
  });

  // Mailgun devuelve JSON; si falla el parseo no rompemos.
  const data = await res.json().catch(() => ({}));
  console.log("[mail] ←", res.status, data);

  if (!res.ok) {
    throw new Error(data?.error || `Fallo envío (HTTP ${res.status})`);
  }
  return data;
}

// Alias opcional para no tocar mucho código viejo (si en algún lado usan "enviarCorreo")
export { enviarMail as enviarCorreo };
